import { twMerge } from "tailwind-merge";

import Icon from "@/components/Icon";
import { Appointment, BookAppointmentResponse } from "@/services/booking";
import { DateUtils } from "@/time";

type Props = {
  appointment: Appointment | BookAppointmentResponse;
  className?: string;
};

function serviceName(
  appointment: Appointment | BookAppointmentResponse,
): string {
  if ("service_name" in appointment) {
    return appointment.service_name;
  } else {
    return appointment.service_description;
  }
}

function storeName(appointment: Appointment | BookAppointmentResponse): string {
  if ("store" in appointment) {
    return appointment.store.name;
  } else {
    return appointment.store_description;
  }
}

export default function AppointmentCard({ appointment, className }: Props) {
  const isAppointmentToday = DateUtils.isAppointmentToday(appointment);

  const service = serviceName(appointment);
  const store = storeName(appointment);

  return (
    <div
      className={twMerge(
        "rounded-md p-4 bg-amalfi-coast/10 flex flex-col gap-3",
        className,
      )}
    >
      <div className="flex items-center gap-2 font-semibold">
        {isAppointmentToday
          ? "TODAY"
          : DateUtils.formatAppointmentDate(appointment)}
        <span className="font-normal">
          {" "}
          at {DateUtils.formatAppointmentTime(appointment)}
        </span>
        <Icon name="calendar" className="ml-auto" aria-hidden />
      </div>
      <div className="font-semibold">{service}</div>
      <div className="text-sm">{store}</div>
    </div>
  );
}
